import { FC, lazy } from 'react';
import { graphql, useFragment } from 'react-relay';
import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense';

import { PdpSharedDealerDetailsReviewContainerLazy_viewer$key } from './__generated__/PdpSharedDealerDetailsReviewContainerLazy_viewer.graphql';
import { PdpSharedDealerDetailsReviewContainerLazy_seller$key } from './__generated__/PdpSharedDealerDetailsReviewContainerLazy_seller.graphql';

type Props = {
    viewer: PdpSharedDealerDetailsReviewContainerLazy_viewer$key;
    seller: PdpSharedDealerDetailsReviewContainerLazy_seller$key;
    isMobile?: boolean;
};

const PdpSharedDealerDetailsReviewContainer = lazy(
    () =>
        import(
            /* webpackChunkName: "PdpSharedDealerDetailsReviewContainer" */ './PdpSharedDealerDetailsReviewContainer'
        )
);

export const PdpSharedDealerDetailsReviewContainerLazy: FC<Props> = ({
    viewer: viewerRef,
    seller: sellerRef,
    isMobile,
}) => {
    const viewer = useFragment(
        graphql`
            fragment PdpSharedDealerDetailsReviewContainerLazy_viewer on Viewer {
                ...PdpSharedDealerDetailsReviewContainer_viewer
            }
        `,
        viewerRef
    );
    const seller = useFragment(
        graphql`
            fragment PdpSharedDealerDetailsReviewContainerLazy_seller on Seller {
                ...PdpSharedDealerDetailsReviewContainer_seller
            }
        `,
        sellerRef
    );

    return (
        <ClientSuspense fallback={null}>
            <PdpSharedDealerDetailsReviewContainer
                viewer={viewer}
                seller={seller}
                isMobile={isMobile}
            />
        </ClientSuspense>
    );
};
